<template>
  <v-container>
    <v-row v-if="loading">
      <v-col cols="12" align="center" justify="center">
        <v-row align="center" justify="center">
          <v-text-field color="success" loading disabled></v-text-field>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="!loading && userCheckIn">
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <v-col cols="6">
              {{ userCheckIn.number }} -
              {{ assessmentDate(userCheckIn) }}
              <span v-if="!userCheckIn.weight" class="pl-4 error--text">(Incomplete)</span>
            </v-col>
          </v-col>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Weight (kg)</th>
                    <th class="text-left">Abdomen (cm)</th>
                    <th class="text-left">Chest (cm)</th>
                    <th class="text-left">Hip (cm)</th>
                    <th class="text-left">Quad (cm)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ userCheckIn.weight }}</td>
                    <td>{{ userCheckIn.abdomen }}</td>
                    <td>{{ userCheckIn.chest }}</td>
                    <td>{{ userCheckIn.hip }}</td>
                    <td>{{ userCheckIn.quad }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="subtitle-1"
            ><h3 style="display: inline">Photos</h3>
            <span class="fake-link" @click="showPhotos = !showPhotos">(View/Hide)</span>
          </v-col>
        </v-row>
        <v-row v-if="showPhotos">
          <v-col cols="4" align="center" justify="center">
            <div v-if="userCheckIn.imgBack">
              <v-img class="grey lighten-2" :src="userCheckIn.imgBack" />
              <v-btn class="mt-4" @click="download(userCheckIn.imgBack, `back`)">
                Download <v-icon color="secondary">save_alt</v-icon>
              </v-btn>
            </div>
            <div v-else>
              <h4>No picture uploaded</h4>
            </div>
          </v-col>
          <v-col cols="4" align="center" justify="center">
            <div v-if="userCheckIn.imgFront">
              <v-img class="grey lighten-2" :src="userCheckIn.imgFront" />
              <v-btn class="mt-4" @click="download(userCheckIn.imgFront, `front`)">
                Download <v-icon color="secondary">save_alt</v-icon>
              </v-btn>
            </div>
            <div v-else>
              <h4>No picture uploaded</h4>
            </div>
          </v-col>
          <v-col cols="4" align="center" justify="center">
            <div v-if="userCheckIn.imgSide">
              <v-img class="grey lighten-2" :src="userCheckIn.imgSide" />
              <v-btn class="mt-4" @click="download(userCheckIn.imgSide, `side`)">
                Download
                <v-icon color="secondary">save_alt</v-icon>
              </v-btn>
            </div>
            <div v-else>
              <h4>No picture uploaded</h4>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="blue-grey lighten-5">
            <AssessmentNotes ref="childNotes" :userId="userId" :assessment="userCheckIn" @reload="reloadAssessments()">
            </AssessmentNotes>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn @click="editAssessment(userCheckIn)">Edit</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div>
      <EditAssessmentForm ref="editAssessment" :close="(editActive = false)"></EditAssessmentForm>
    </div>
  </v-container>
</template>

<script>
import { ASSESSMENT_QUERY } from "@/constants/graphql/assessments/assessment";
import EditAssessmentForm from "@/components/assessment/forms/EditAssessmentForm";
import AssessmentNotes from "./AssessmentNotes";
import { fancy_date } from "@/lib/fancy_date";
import FileDownloadMixin from "@/components/shared/mixins/FileDownloadMixin";

export default {
  name: "Assessment",
  mixins: [FileDownloadMixin],
  props: ["assessmentId", "userId"],
  components: {
    EditAssessmentForm,
    AssessmentNotes,
  },
  data() {
    return {
      loading: true,
      editActive: false,
      userCheckIn: {},
      formKey: 0,
      showPhotos: false,
    };
  },
  methods: {
    fancyDate(date) {
      return fancy_date(date, "ddd, D MMM YYYY");
    },
    assessmentDate(assessment) {
      return assessment.assessmentDate
        ? this.fancyDate(assessment.assessmentDate)
        : this.fancyDate(assessment.requiredDate);
    },
    editingNotes() {
      let editing = false;
      this.$refs.childNotes.forEach((notesComponent) => {
        if (notesComponent.currentlyEditing()) {
          editing = true;
          return;
        }
      });
      return editing;
    },
    editAssessment(assessment) {
      this.$refs.editAssessment.open(assessment);
    },
    reloadAssessments() {
      this.$apollo.queries.assessment.refetch();
    },
  },
  apollo: {
    userCheckIn: {
      query: ASSESSMENT_QUERY,
      variables() {
        let encoded_json_payload = btoa("UserCheckInNode:" + this.assessmentId);
        return {
          id: encoded_json_payload,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.loading = false;
        }
      },
    },
  },
};
</script>

<style scoped>
.fake-link {
  cursor: pointer;
  padding-left: 5px;
}

.fake-link:hover {
  text-decoration: underline;
}
</style>
